import type { Static } from 'runtypes';
import { Number, Record, String } from 'runtypes';

const AppContextRuntype = Record({
  buildDate: String,
  gitCommit: String,
  name: String,
  version: Number,
});

type AppContext = Static<typeof AppContextRuntype>;

export { AppContextRuntype };
export type { AppContext };
